import { observer } from 'mobx-react';
import { Fragment, useEffect } from 'react';
import useHistory from '../../../../hooks/useHistory';
import { useStore } from '../../../../store/store';
import { isPhoneOrTablet } from '../../../../utils/utils';

const SearchFormMobileSection = observer(
  ({ section = null, onBack = null, fields = {}, hideMandatoryHint = false }) => {
    const { utilsStore } = useStore();
    const { navigate, location } = useHistory();

    useEffect(() => {
      navigate(location.pathname + location.search);
      addEventListener('popstate', onBack);
      return () => {
        removeEventListener('popstate', onBack);
      };
    }, []);

    useEffect(() => {
      if (utilsStore.windowWidth > 1200) {
        navigate(-1);
      }
    }, [utilsStore.windowWidth]);

    return (
      <div
        className={`mobile-fields-wrapper ${isPhoneOrTablet ? 'isPhoneOrMobile' : 'notPhoneOrMobile'}`}>
        <button className="backlink" onClick={() => navigate(-1)}>
          Search
        </button>
        <div className="mobile-fields">
          {Object.values(fields[section]).map((field, idx) => (
            <Fragment key={idx}>{field}</Fragment>
          ))}
        </div>
        {!hideMandatoryHint && (
          <div className="mobile-fields-mandatory-row">
            <font className="red-asterisk">*</font>mandatory fields
          </div>
        )}
      </div>
    );
  }
);

export default SearchFormMobileSection;
